export const HOST = '/api'